// Показателите на „Дневник на резервациите" — върху показаните редове.
//
// Водещото число е броят резервации; до него хората (гостите и средната
// група), после как е завършило (приключили / отказани / неизпълнени с
// процента неявяване) и накрая оборотът от сметките на настанените.

import { useTranslation } from "react-i18next";

import { formatNumber } from "../../../../components/dataTable";
import { fmtEuro } from "../../../../utils/currency";
import { ReportKpiCard } from "../ReportKpiCard";
import { noShowRate } from "./reservationReportFormat";
import type { JournalSummaryView } from "./journalMath";

type Props = {
  summary: JournalSummaryView;
  isNarrow: boolean;
};

export const JournalKpis = ({ summary, isNarrow }: Props) => {
  const { t } = useTranslation();
  const noShow = noShowRate(summary);

  return (
    // Класовете са ЦЕЛИ литерали: Tailwind сканира изходния текст и не вижда
    // име, сглобено с template literal.
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-6"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiReservations")}
        value={String(summary.reservations)}
        sub={t("reportsPage.rvKpiReservationsSub", {
          upcoming: summary.upcoming,
          seated: summary.seated,
        })}
        hero
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiGuests")}
        value={String(summary.guests)}
        sub={
          summary.averageParty === null
            ? t("reportsPage.rvKpiGuestsSub")
            : t("reportsPage.rvKpiAverageParty", {
                value: formatNumber(summary.averageParty, 1),
              })
        }
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvStatus_completed")}
        value={String(summary.completed)}
        sub={t("reportsPage.rvKpiCompletedSub")}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvStatus_cancelled")}
        value={String(summary.cancelled)}
        sub={t("reportsPage.rvKpiCancelledSub")}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvStatus_expired")}
        value={String(summary.expired)}
        sub={
          noShow === null
            ? t("reportsPage.rvKpiNoShowNone")
            : t("reportsPage.rvKpiNoShowRate", {
                value: formatNumber(noShow, 1),
              })
        }
        hot={summary.expired > 0}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiRevenue")}
        value={fmtEuro(summary.revenue)}
        sub={t("reportsPage.rvKpiRevenueSub")}
      />
    </div>
  );
};
